<template>
    <div class="echart-line"  ref="echartsPieRef" style="height: 400px; width: 100%"></div>
</template>

<script>
import * as echarts from 'echarts';
import macarons from  '@/apis/macarons'
import {getHomeStaticPie} from "@/apis/static";
export default {
    name: 'EchartLine',
    props : {
        search : Object
    },
    components: {

    },
    data () {
        return {
            option: {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '5%',
                    left: 'center'
                },
                series: [
                    {
                        name: '项目支出',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        padAngle: 5,
                        itemStyle: {
                            borderRadius: 10
                        },
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 40,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: 0, name: '采购支出' },
                            { value: 0, name: '报销支出' }
                        ]
                    }
                ]
            }
        }
    },
    created(){

    },
    mounted(){
        this.$nextTick(() => {
            this.GetLineEchart();
        })
    },
    methods:{
        GetLineEchart(){
            let that = this;
            getHomeStaticPie().then(e=>{
                that.option.series[0].data[0].value = e.data.expend_money ?? 0;
                that.option.series[0].data[1].value = e.data.expense_money ?? 0;
                const chartDom = that.$refs.echartsPieRef;
                echarts.registerTheme('macarons', macarons);
                const myChart = echarts.init(chartDom, macarons);
                myChart.setOption(that.option);
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
